Vendd.Scripts.load(function () {
    if (isTouch())
        return;

    if ($('.pager select').length > 0)
        $('.pager select').sSelect({ddMaxHeight: '200px'});
});

